import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandProfile } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = BrandProfile | undefined

export const fetchBrandProfile = async ({ workspaceId, signal }: { workspaceId: number; signal?: AbortSignal }) => {
  const res = await sendToApi<{ brand_profile: BrandProfile }>(`/w/${workspaceId}/brand_profile`, { signal })

  if (res.type === 'error' && res.status === 404) {
    return undefined
  }

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.brand_profile
}

export const useBrandProfile = (options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(['workspaces', workspaceId, 'brandProfile'], () => fetchBrandProfile({ workspaceId }), {
    refetchOnWindowFocus: false,
    staleTime: (options?.cacheTime || 0) * 0.5,
    ...options,
  })
}
